module.exports = __webpack_public_path__ + "static/media/game(28).bdcfd425.PNG";